import React from 'react';
import { Selectable } from 'kysely';
import { SessionFiles } from '../helpers/schema';

interface ErrorItem {
  file: string;
  line: number;
  message: string;
}

interface ErrorsPanelProps {
  sessionId: string;
  files: Selectable<SessionFiles>[];
  onSelectFile: (fileId: string) => void;
  errors: ErrorItem[];
}

export const ErrorsPanel: React.FC<ErrorsPanelProps> = ({
  sessionId,
  files,
  onSelectFile,
  errors,
}) => {
  const handleErrorClick = (error: ErrorItem) => {
    // Parse the file path
    const filePath = error.file.replace(/\\/g, '/').split('/').pop() || '';
    const fileName = filePath;
    const filePathDir = error.file.replace(/\\/g, '/').replace('/' + fileName, '') || '';

    // Find the file
    const file = files.find((f) => f.fileName === fileName && f.filePath === filePathDir);
    if (file) {
      onSelectFile(file.id);
      // TODO: scroll to line
    }
  };

  return (
    <div style={{ color: 'red', fontFamily: 'monospace' }}>
      <h3>Errors</h3>
      <ul>
        {errors.map((error, index) => (
          <li key={index} style={{ marginBottom: '0.5rem' }}>
            <button
              onClick={() => handleErrorClick(error)}
              style={{
                color: 'red',
                textDecoration: 'underline',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              {error.file}:{error.line}
            </button>
            : {error.message}
          </li>
        ))}
      </ul>
    </div>
  );
};
